import React from "react";
import { connect } from "react-redux";
import Dashboard from "powerbi-report-component";
import { push } from "connected-react-router";
import { checkAccess, ids, realCheckAccess } from "../../../../helpers/rolAccess";
import { paths } from "../../../../config/routes";
const config = {};


class DatosEmpresaGrafico extends React.PureComponent {
  constructor(props){
    super(props);
    this.state = {
      style: {
        height: "100%",
        border: "0",
        padding: "0px",
        background: "#eee",
      }
    };
  }

  componentDidUpdate = (prevProps) => {
    if (prevProps.companyId !== this.props.companyId) {
      this.props.dispatch(push(paths.root))
    }
  }

  setHeight = () => {
    const {style} = this.state;
    this.setState({style: {...style, height:'100%'}});
  }

  render() {
    const reporte = [];
    if (this.props.companyId) {
      config.embedUrl = `${this.props.config.embedUrl}&pageName=ReportSection48ead6718e3196755c41&filter=Tabla_x0020_Ruts_x0020_Empresa/Rut eq '${this.props.companyId.replace('-','')}'`;
      config.extraSettings = {
        filterPaneEnabled: false,
        navContentPaneEnabled: false,
        allowFullScreen: false,
      };

      const key = `datosEmpresa${new Date().getTime()}`;
      reporte.push(<Dashboard
        key={key}
        embedType={this.props.config.embedType}
        tokenType={this.props.config.tokenType}
        accessToken={this.props.EmbedTokenPowerBi}
        embedUrl={config.embedUrl}
        embedId={this.props.config.embedId}
        pageName={'ReportSection48ead6718e3196755c41'}
        extraSettings={{
          filterPaneEnabled: config.extraSettings.filterPaneEnabled,
          navContentPaneEnabled: config.extraSettings.navContentPaneEnabled,
        }}
        permissions="All"
        style={this.state.style}

      />);
    }


    return (
      <React.Fragment>
        <div className='header-subTitle' style={{ marginBottom: 5, marginTop: 0 }}>Visualiza el detalle de los datos por empresa y trabajador.</div>
        {reporte}
      </React.Fragment>

    );
  }
}
const mapStateToProps = (state) => ({
  config: state.graficos.config,
  EmbedTokenPowerBi: state.graficos.EmbedTokenPowerBi,
  companyId: state.global.companyId,
  //sucursalId: state.global.sucursalId,
  userAccessIds: state.global.userAccessIds,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch: (action) => { dispatch(action); },
});

export default connect(mapStateToProps, mapDispatchToProps)(DatosEmpresaGrafico
);

